import { useState, useEffect } from 'react'

const useResponsiveView = (customBreakpoint) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [isDevice, setIsDevice] = useState(false)
  const [isDesktop, setIsDesktop] = useState(false)
  const [breakpoint, setBreakpoint] = useState({})

  useEffect(() => {
    const checkView = () => {
      const width = window.innerWidth
      setIsMobile(width <= 767)
      setIsTablet(width > 767 && width <= 992)
      setIsDevice(width <= 992)
      setIsDesktop(width > 992)
      if (customBreakpoint) {
        setBreakpoint({
          up: width > customBreakpoint,
          down: width <= customBreakpoint,
        })
      }
    }

    checkView()
    window.addEventListener('resize', checkView)
    return () => window.removeEventListener('resize', checkView)
  }, [])

  return { isMobile, isTablet, isDevice, isDesktop, breakpoint }
}

export default useResponsiveView
